import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

const ReleaseListItems = ({
  studySource,
  studyType,
  title,
  releaseDate,
}) => {
  return (
    <div className="resources__releases--list--item-card">
      <div className="resources__releases--release-date">
        <div className="resources__releases--year">
          {moment(releaseDate).format('YYYY')}
        </div>
        <div className="resources__releases--month">
          {moment(releaseDate).format('MMMM')}
        </div>
        <div className="resources__releases--date">
          {moment(releaseDate).format('DD')}
        </div>
      </div>
      <div className="resources__releases--study">
        <div className="resources__releases--study--left">
          <div className="resources__releases--study-category" dangerouslySetInnerHTML={{ __html: studyType }} />
          <div className="resources__releases--study-name" dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <div className="resources__releases--study--right">
          <div
            className={`${studySource === 'MRI' ? 'resources__releases--study-source-mri' : 'resources__releases--study-source'}`}
          >
            {studySource}
          </div>
        </div>
      </div>
    </div>
  );
};

ReleaseListItems.propTypes = {
  studySource: PropTypes.string,
  studyType: PropTypes.string,
  title: PropTypes.string,
  releaseDate: PropTypes.number,
};

export default ReleaseListItems;
